const clientName = localStorage.getItem('clientName');
const clientId = localStorage.getItem('clientId');
const email = localStorage.getItem('clientEmail');


const getLoginUserData = () => {
    //userid null or 0 or undefined

    if (clientId !== null && clientName !== null || email !== null) {

        const data = {
            name: clientName,
            email: email,
            id: clientId,
        }

        return data;
    }
    else {
        alert("there is some issue please re-login ");
        window.location.href = "/";
        sessionStorage.clear();
    }

}
const formattedDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
        year: 'numeric',
        month: 'long', // Full month name (e.g., January)
        day: 'numeric',
        weekday: 'long', // Full weekday name (e.g., Monday)
    };

    // Use toLocaleDateString to format the date based on the options
    return date.toLocaleDateString('en-US', options);
}

export { formattedDate, getLoginUserData }